import { render } from "./CommentEditDropdown.vue?vue&type=template&id=2868e49c&scoped=true"
import script from "./CommentEditDropdown.vue?vue&type=script&lang=js"
export * from "./CommentEditDropdown.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2868e49c"

export default script